
<div class="header-toolbar">
  <h1>
    {{ title }}
    <span>{{ ledger?.name }}</span>
  </h1>
</div>


<form #form="ngForm" autocomplete="off" *ngIf="ledger">

  <!-- Toolbar -->
  <div class="main btn-toolbar">
        
    <a class="btn" (click)="cancel()">
      <t-icon name="arrow_back"></t-icon>
      <span class="text">Retour</span>
    </a>

  </div>
  <!-- /Toolbar -->

  <div class="grid" *ngIf="company">

    <div class="column">

      <div class="panel">
        <h2>Registre</h2>
      
        <div class="form-group">
          <label for="name">Nom</label>
          <span id="name" class="value">{{ ledger.name }}</span>
        </div>
      </div>
      
      <div class="panel">
        <h2>Liste des documents</h2>
      
        <table class="attachments">
          <tbody>
            <tr *ngFor="let document of documents">
              
              <!--Details-->
              <td>
                {{ document.model.filename }}

                <dl-document-form [document]="document" *ngIf="document.edit"></dl-document-form>
        
                <div class="item-details" *ngIf="!document.edit">
                  <div>
                    <label>Commentaire</label>
                    <span>{{ document.model.comment | empty }}</span>
                  </div>

                  <div>
                    <label>Date</label>
                    <span>{{ document.model.date | documentdate }}</span>
                  </div>

                  <div>
                    <label>Taille</label>
                    <span>{{ document.model.filesize | filesize }}</span>
                  </div>
                </div>
        
              </td>
        
              <td style="width: 100px;" class="actions">
                <ng-container *ngIf="document.edit">
                  <a class="action-btn" title="Enregistrer" (click)="update(document)">
                    <t-icon name="check"></t-icon>
                  </a>

                  <a class="action-btn" title="Annuler" (click)="cancelEdit(document)">
                    <t-icon name="close"></t-icon>
                  </a>
                </ng-container>

                <ng-container *ngIf="!document.edit">
                  <a class="action-btn" title="Modifier" (click)="edit(document)">
                    <t-icon name="mode_edit"></t-icon>
                  </a>

                  <a class="action-btn" title="Supprimer" (click)="delete(document.model)">
                    <t-icon name="delete"></t-icon>
                  </a>
                </ng-container>
              </td>
        
            </tr>
          </tbody>
        </table>
      
        <div class="empty-table compact" *ngIf="ledger.documents.length === 0">
          <p>Aucun document dans ce registre</p>
        </div>
      
      </div>

    </div>
    
    <div class="column">

      <!-- Attachment edit -->
      <div class="panel">
        <h2>Ajouter des documents</h2>
        
        <table class="attachments">
          <tbody>
            <tr *ngFor="let item of items">
              
              <!--Icons-->
              <td class="icons" *ngIf="item.status === 'START'">
                <t-icon name="query_builder"></t-icon>
              </td>
              
              <td class="icons small-percent" *ngIf="item.status === 'UPLOADING'">
                <t-percent [total]="100" [value]="item.progress" [showValue]="false" [size]="20" [radius]="8"></t-percent>
              </td>
              
              <td class="icons" *ngIf="item.status === 'PROCESSING'">
                <t-icon name="fingerprint" class="digest"></t-icon>
              </td>
              
              <td class="icons" *ngIf="item.status === 'DONE'">
                <t-icon name="check_circle_outline" class="success"></t-icon>
              </td>

              <td class="icons" *ngIf="item.status === 'UNAUTHENTICATED'">
                <t-icon name="warning" class="error"></t-icon>
              </td>

              <td class="icons" *ngIf="item.status === 'UNVERIFIED'">
                <t-icon name="warning" class="error"></t-icon>
              </td>
              
              <td class="icons" *ngIf="item.status === 'ERROR'">
                <t-icon name="warning" class="error"></t-icon>
              </td>

  
              <!--Details-->
              <td>
                {{ item.model.filename }}

                <dl-document-form [document]="item" *ngIf="item.status === 'DONE' || item.status === 'UNAUTHENTICATED'"></dl-document-form>
  
                <div class="item-details" *ngIf="item.status === 'START'">
                  <div>
                    <label>Statut</label>
                    <span>Préparation...</span>
                  </div>
                </div>

                <div class="item-details" *ngIf="item.status === 'UPLOADING'">
                  <div>
                    <label>Statut</label>
                    <span>Téléchargement {{ item.progress }}%</span>
                  </div>
                </div>

                <div class="item-details" *ngIf="item.status === 'PROCESSING'">
                  <div>
                    <label>Statut</label>
                    <span>Vérification de la signature numérique...</span>
                  </div>
                </div>

                <div class="item-details" *ngIf="item.status === 'DONE'">
                  <div *ngIf="ledger.signed">
                    <label>Signé avec</label>
                    <span class="digest" title="{{ item.verification.rootCertificateName }}">
                      {{ item.verification.rootCertificateName}}
                    </span>
                  </div>
                  <div>
                    <label>Taille</label>
                    <span>{{ item.model.filesize | filesize }}</span>
                  </div>
                </div>

                <div class="item-details" *ngIf="item.status === 'UNAUTHENTICATED'">
                  <div>
                    <label>Statut</label>
                    <span>
                      {{ item.verification.unverifiedReason.message }}
                    </span>
                  </div>
                  <div *ngIf="item.verification.authenticity === false && item.verification.meta">
                    <label>Certificats</label>
                    <span>
                      <ul>
                        <li *ngFor="let cert of item.verification.meta?.certs">
                          {{ cert.issuedBy.commonName }}
                        </li>
                      </ul>
                    </span>
                  </div>
                </div>

                <div class="item-details" *ngIf="item.status === 'UNVERIFIED'">
                  <div>
                    <label>Statut</label>
                    <span>
                      {{ item.verification.unverifiedReason.message }}
                    </span>
                  </div>
                </div>

                <div class="item-details" *ngIf="item.status === 'ERROR'">
                  <div>
                    <label>Statut</label>
                    <span>Une erreur s'est produite, veuillez supprimer ce fichier et réessayer</span>
                  </div>
                </div>

              </td>
  
              <td style="width: 100px;" class="actions">
                <a class="action-btn" *ngIf="item.status === 'DONE'" title="Ajouter le document" (click)="addDocument(item)">
                  <t-icon name="check"></t-icon>
                </a>

                <a class="action-btn" *ngIf="item.status === 'UNAUTHENTICATED'" title="Ajouter le document et son certificat racine" (click)="addDocument(item)">
                  <t-icon name="check"></t-icon>
                </a>

                <a class="action-btn" (click)="removeItem(item)" title="Supprimer le document">
                  <t-icon name="delete"></t-icon>
                </a>
              </td>

            </tr>
          </tbody>
        </table>

        <div class="form-group">
          <label class="file-select"
            ng2FileDrop
            (fileOver)="isFileOver = $event"
            [uploader]="uploader"
            [ngClass]="{ 'over': isFileOver }"
            for="file"
            >
            <t-icon name="attachment"></t-icon>
            <span class="text">Joindre un ou plusieurs fichiers</span>
          </label>
          <input id="file" type="file" style="display: none" ng2FileSelect multiple (onFileSelected)="onUploadItemAdded($event)" [uploader]="uploader" />
        </div>

      </div>

    </div>

  </div>
</form>